/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import { library } from "@fortawesome/fontawesome-svg-core";

import { faPaperPlane, faTag } from "@fortawesome/free-solid-svg-icons";
import { faEdit as faEditRegular } from "@fortawesome/free-regular-svg-icons";

library.add(
  faPaperPlane,
  faTag,
  faEditRegular
  // more icons go here
);
